/**
 * Inject Wonderly overrides after third-party cart summary app widgets render.
 */
(function () {
  const STYLE_ID = 'wonderly-appstle-cart-styles';
  const WIDGET_SELECTOR = '#appstle-loyalty-redeem-widget-block';

  function injectStyles(href) {
    if (!href) return;

    let link = document.getElementById(STYLE_ID);

    if (!link) {
      link = document.createElement('link');
      link.id = STYLE_ID;
      link.rel = 'stylesheet';
      link.href = href;
    }

    document.head.appendChild(link);
  }

  function init() {
    const footer = document.querySelector('#main-cart-footer.wonderly-cart-page__footer');
    if (!footer) return;

    const href = footer.dataset.appstleStyles;
    if (!href) return;

    const sync = () => {
      if (footer.querySelector(WIDGET_SELECTOR)) {
        injectStyles(href);
      }
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(footer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
